const CREATE_NEW_SLIDE = 'Create new slide'
const START_PRESENTING = 'start presenting'

// Presentation creation triggers
const PRESENTATION_TRIGGERS = {
  FROM_ONBOARDING: 'From onboarding',
}

export {
  CREATE_NEW_SLIDE,
  START_PRESENTING,
  PRESENTATION_TRIGGERS,
}
